{
  "sampling": {
    "title": "Amostragem",
    "evenDistribution": "Distribuição uniforme (quadrada)",
    "evenDistributionDescription": "Distribua o lote uniformemente em faixas de um campo filtrado.",
    "bucketField": "Campo de agrupamento",
    "bucketFieldPlaceholder": "Selecione um campo",
    "bucketSize": "Incremento da faixa",
    "min": "Mín",
    "max": "Máx",
    "shuffle": "Embaralhar ordem de apresentação",
    "shuffleDescription": "Os registros são apresentados a cada rotulador em ordem aleatória.",
    "perBucketNote": "≈{{quota}} por faixa em {{buckets}} faixas",
    "rangeError": "Mín deve ser menor que Máx"
  },
  "filters": {
    "title": "Filtros",
    "field": "Campo",
    "fieldPlaceholder": "Selecione o campo",
    "incomplete": "Selecione um campo e ambos os limites, ou limpe a linha",
    "add": "+ Adicionar filtro",
    "remove": "Remover filtro"
  },
  "bucketCoverage": {
    "title": "Cobertura por faixa",
    "target": "Meta",
    "included": "Incluídos",
    "available": "Disponíveis",
    "bucketTooltip": "{{included}} de {{target}} incluídos ({{available}} disponíveis)"
  },
  "common": {
    "name": "Nome",
    "description": "Descrição",
    "status": "Status",
    "customer": "Cliente",
    "project": "Projeto",
    "projects": "Projetos",
    "targetSize": "Tamanho Alvo",
    "createProject": "Criar Projeto",
    "editProject": "Editar Projeto",
    "createBatch": "Criar Lote",
    "createRound": "Criar Rodada",
    "save": "Salvar",
    "min": "Mín",
    "max": "Máx",
    "yes": "Sim",
    "no": "Não",
    "noImage": "Sem imagem"
  },
  "projectsList": {
    "statusActive": "Ativo",
    "statusDraft": "Rascunho"
  },
  "projectDashboard": {
    "titleFallback": "Painel do Projeto",
    "noRounds": "Sem rodadas",
    "roundSummary": "{{roundName}}: {{complete}}/{{total}} concluídas",
    "roundsColumn": "Rodadas",
    "createdColumn": "Criado em",
    "actionsColumn": "Ações",
    "batchesTitle": "Lotes"
  },
  "projectSetup": {
    "newProject": "Novo Projeto",
    "editBreadcrumb": "Editar",
    "projectNameLabel": "Nome do Projeto",
    "projectNamePlaceholder": "Digite o nome do projeto",
    "descriptionPlaceholder": "Digite a descrição do projeto",
    "customerPlaceholder": "Selecione o cliente",
    "dataSourceTypeLabel": "Tipo de Fonte de Dados",
    "dataSourceTypePlaceholder": "Selecione o tipo de fonte de dados",
    "schemaLockedTitle": "Esquema Bloqueado",
    "schemaLockedMessage": "O esquema de rótulos está bloqueado e não pode ser modificado.",
    "projectNameRequired": "Nome do Projeto é obrigatório",
    "customerRequired": "Cliente é obrigatório"
  },
  "schemaBuilder": {
    "title": "Esquema de Rótulos",
    "noFieldsDefined": "Nenhum campo definido.",
    "noFieldsYet": "Nenhum campo adicionado ainda. Clique em \"Adicionar Campo\" para definir seu esquema de rótulos.",
    "addField": "Adicionar Campo",
    "fieldKeyLabel": "Chave do Campo",
    "fieldKeyPlaceholder": "Digite a chave do campo",
    "fieldLabelLabel": "Rótulo do Campo",
    "fieldLabelPlaceholder": "Digite o rótulo do campo",
    "typeLabel": "Tipo",
    "typeText": "Texto",
    "typeNumeric": "Numérico",
    "typeSingleSelect": "Seleção Única",
    "typeMultiSelect": "Seleção Múltipla",
    "typeBoolean": "Booleano",
    "requiredLabel": "Obrigatório",
    "minimumPlaceholder": "Mínimo",
    "maximumPlaceholder": "Máximo",
    "stepLabel": "Passo",
    "stepPlaceholder": "Passo",
    "addOptionPlaceholder": "Adicionar opção"
  },
  "batchCuration": {
    "invalidRoute": "Rota inválida: ID do projeto ou do lote ausente",
    "batchFallback": "Lote",
    "titleFallback": "Curadoria do Lote",
    "finaliseButton": "Finalizar Lote",
    "finaliseConfirm": "Tem certeza que deseja finalizar este lote? Esta ação não pode ser desfeita.",
    "includedWord": "incluídos",
    "excludedWord": "excluídos",
    "totalWord": "no total",
    "trimNote": "{{count}} extras serão removidos ao finalizar",
    "shortNote": "faltam {{count}} para a meta",
    "batchConfigTitle": "Configuração do Lote",
    "refetchButton": "Buscar Novamente"
  },
  "imageResults": {
    "title": "Resultados de Imagens",
    "viewAllImages": "Ver todas as imagens",
    "included": "Incluído",
    "excluded": "Excluído",
    "includeButton": "Incluir",
    "excludeButton": "Excluir"
  },
  "allImages": {
    "title": "Todas as Imagens",
    "imagesCount": "{{count}} imagens",
    "removeSelected": "Remover Selecionadas ({{count}})"
  },
  "batchCreation": {
    "batchNameLabel": "Nome do Lote",
    "batchNamePlaceholder": "Digite o nome do lote",
    "descriptionPlaceholder": "Digite a descrição do lote",
    "targetSizePlaceholder": "Digite o tamanho alvo",
    "extractButton": "Extrair",
    "batchNameRequired": "Nome do lote é obrigatório",
    "targetSizeRequired": "Tamanho alvo é obrigatório",
    "targetSizeMin": "Tamanho alvo deve ser no mínimo 1"
  },
  "createRound": {
    "roundNameLabel": "Nome da Rodada",
    "roundNamePlaceholder": "Digite o nome da rodada",
    "roundNameRequired": "Nome da rodada é obrigatório",
    "assigneesLabel": "Responsáveis",
    "assigneesPlaceholder": "Selecione os responsáveis"
  },
  "dataSourceParams": {
    "enterPlaceholder": "Digite {{label}}",
    "selectPlaceholder": "Selecione {{label}}",
    "uploadCsv": "Enviar CSV",
    "changeFile": "Alterar arquivo",
    "selectOrgFirst": "Selecione a organização primeiro"
  },
  "labelling": {
    "assignmentNotFound": "Tarefa não encontrada",
    "noRecords": "Nenhum registro para rotular",
    "noRecordSelected": "Nenhum registro selecionado",
    "completeBadge": "Concluída",
    "submit": "Enviar tarefa",
    "next": "Próximo",
    "recordsHeader": "Registros",
    "labelledProgress": "Rotulados {{labelled}} de {{total}}",
    "noImageAvailable": "Nenhuma imagem disponível",
    "unsupportedFieldType": "Tipo de campo não suportado para \"{{label}}\""
  }
}
